
<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-page-header @back="goBack" :content="$route.query.id!=undefined ? '商品编辑':'商品添加'"></el-page-header>
      </div>
      <div  class="text item">
        <el-form ref="form" :model="form" label-width="120px" style="width: 80%;">
          <el-form-item label="商品标题">
            <el-input v-model="form.title" :rules="{required: true, message: '商品标题', trigger: 'blur'}"></el-input>
          </el-form-item>
          <el-form-item label="商品分类">
            <el-select v-model="form.category_id" placeholder="请选择分类" :rules="{required: true, message: '商品标题', trigger: 'blur'}">
              <el-option :label="item.name" :value="item.category_id" v-for="(item,index) in category" :key="index" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品信息">

            <div class="goods" v-if="form.goods_info!=undefined && form.goods_info[0]!=undefined" style="width:400px">
              <div class="goods-thumbnail">
                <img :src="form.goods_info[0].pics" alt="" style="width: 100px">
              </div>
              <div class="goods-caption">
                <div class="goods-title">
                  {{form.goods_info[0].item_title}}
                  <span style="color:red"  v-if="form.goods_info[0].special_type == 'drug'" >处方药</span>
                  <span style="color:blue" v-else>非处方药</span>
                  <span class="goods-remove iconfont icon-trash-alt" @click="handleSkuRemove()"></span>
                </div>
              </div>
            </div>
            <div v-else>
              <SkuSelector  @change="getItems" :data="relItems"></SkuSelector>
            </div>

          </el-form-item>
          <el-form-item label="是否厂家合作">
            <el-radio-group v-model="form.is_manufactor">
              <el-radio :label="0" >否</el-radio>
              <el-radio :label="1" >是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="商品是否可用">
            <el-radio-group v-model="form.is_can_use">
              <el-radio :label="0" >否</el-radio>
              <el-radio :label="1" >是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="过期方式">
            <el-radio-group v-model="form.type">
              <el-radio :label="0">灵活过期(自签约之日起按有效期灵活过期)</el-radio>
              <el-radio :label="1">统一过期(统一过期时间设定后，请勿随意更改)</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="活动时间" >
            <el-col :span="6">
              <el-date-picker type="date"
                              value-format="yyyy-MM-dd"
                              placeholder="选择日期" v-model="form.begin_time" style="width: 100%;"></el-date-picker>
            </el-col>
            <el-col :span="1" style="text-align: center">-</el-col>
            <el-col :span="6">
              <el-date-picker type="date" placeholder="选择时间"
                              value-format="yyyy-MM-dd"
                              v-model="form.end_time"  style="width: 100%;"></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="活动时间" v-if="form.type == 0">
            <el-input v-model="form.days"   placeholder="活动时间(天数)"></el-input>
          </el-form-item>
          <el-form-item label="活动描述">
            <el-input type="textarea" v-model="form.description" placeholder="共x期限，最高省X元"></el-input>
          </el-form-item>
          <el-form-item label="合约说明">
            <el-input type="textarea" v-model="form.content"></el-input>
          </el-form-item>
          <el-form-item label="优惠券激活策略">
            <el-form-item
                  v-for="(item, index) in form.rule"
                  :label="'规则.' + (index+1) "
                  :key="index"
                  :prop="'rule.' + index + '.value'"
                  :rules="rules">
              <el-select v-model="item.card_id" @change="changeCard(index)" placeholder="请选择优惠券" filterable >
                <el-option :label="v.title" :value="v.card_id" v-for="(v,i) in cardList" :key="v.card_id" ></el-option>
              </el-select>
                <el-input v-model="item.level"   placeholder="等级" style="width: 100px;display: none"></el-input>
              <el-select v-model="item.number" placeholder="数量" style="width:80px" >
                <el-option :label="v" :value="v" v-for="(v,i) in 20" :key="i" ></el-option>
              </el-select>
              <el-select v-model="item.expiry_time" placeholder="自领券后多少天过期" style="width:200px"  >
                <el-option :label="v" :value="v" v-for="(v,i) in 100" :key="i" ></el-option>
              </el-select>
              <el-input type="text" v-model="item.message" placeholder="说明(第~几盒)" style="width:200px" ></el-input>
              <el-input type="text" v-model="item.info" style="display: none" ></el-input>
              <el-button @click.prevent="removeRule(item)">删除</el-button>
            </el-form-item>
            <el-button type="text" @click="addRule"  >+增加规则</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
            <el-button @click="goBack">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getCategoryList,saveGoods,getGoodsRow } from '@/api/long'
import { getCardList} from '@/api/cardticket'
import SkuSelector from '@/components/function/skuSelector'
export default {
  inject: ['refresh'],
  data() {
    return {
      category: [],
      goodsShow:false,
      form: {
        title: '',
        category_id: '',
        is_can_use:1,
        is_manufactor:0,
        description: '',
        days:365,
        rule: [{
          level:1,
          number:3,
          card_id:'',
          expiry_time:30,
          message:'',
          info:'',
        },
          {
            level:2,
            number:3,
            card_id:'',
            expiry_time:30,
            message:'',
            info:'',
          },
          {
            level:3,
            number:3,
            card_id:'',
            expiry_time:30,
            message:'',
            info:'',
          },
        ],
        begin_time: '',
        end_time: '',
        type: 0,
        goods_info: [],
        content: '',
        coupon_info:''
      },
      relItems: [],
      relItemsIds: [],
      addedItems: [],
      rules:{ required: true, message: '规则不能为空', trigger: 'blur'},
      cardList:[],
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  components:{
    SkuSelector
  },
  methods: {
    addRule(){
        console.log(this.form.rule.length)
        this.form.rule.push({
          level:this.form.rule.length+1,
          number:3,
          card_id:'',
          expiry_time:30,
          message:'',
          info:'',
        });

    },
    removeRule(item){
      var index = this.form.rule.indexOf(item)
      if (index !== -1) {
        this.form.rule.splice(index, 1)
      }
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    goBack() {
      this.$confirm('此操作返回上一个页面, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        history.back(0)
      }).catch(() => {})
    },

    getCategory(){
      getCategoryList({}).then(res=>{
        if(res.data){
          this.category = res.data.data
        }
      })
    },
    getCard(){
      getCardList({receive:false,is_long:1,page:1,page_size:10000}).then(res=>{
        if(res.data){
          this.cardList = res.data.data.list
        }
      })
    },
    changeCard(index){
      var card = this.form.rule[index].card_id
      var i=this.cardList.map((item) => item.card_id).indexOf(card);
      this.form.rule[index].info=JSON.stringify(this.cardList[i]);
    },
    getItems(data) {
      let arr = []
        data.forEach((item, index) => {
          let newData = ''
          let isInArr = this.addedItems.findIndex((n) => n.item_id == item.itemId)
          if (isInArr == -1) {
            newData = {
              item_id: item.itemId,
              item_bn: item.itemBn,
              item_title: item.itemName,
              pics:item.pics[0],
              spec:item.spec,
              brief:item.brief,
              activity_store:9999, // 默认设置活动库存 9999
              special_type: item.special_type,
              activity_price: item.price/100,
              item_spec_desc: item.item_spec_desc,
              sort: item.sort,
              limit_num: 1,
              item_type: item.item_type
            }
          } else {
            newData = this.addedItems[index]
          }
          arr.push(newData)
        })
        this.form.goods_info= arr
    },
    //编辑显示数据
    getRow(id){
      getGoodsRow(id).then(res=>{
        if(res.data){
          this.form = res.data;
        }
      })
    },
    onSubmit() {
      if(this.$route.query.id){
        this.form.goods_id=this.$route.query.id
      }
      if(this.form.goods_info == ''){
        this.$message.error('商品不能为空!')
        return false
      }
      if(this.form.title == ''){
        this.$message.error('标题不能为空!')
        return false
      }
      if(this.form.type == 1 && (this.form.begin_time == '' || this.form.end_time == '')){
        this.$message.error('统一过期，需要设置活动时间!')
        return false
      }
      var that=this
      saveGoods(this.form).then(res=>{
        if(res.status ){
          this.loading = false
          this.$message({
            message: '保存成功',
            type: 'success',
            duration: 2000
          })
          setTimeout(function (){
            that.$router.go(-1)
          },2000)
        } else {
            this.$message.error('保存失败!')
            return false
        }
      })

    },
    handleSkuRemove(){
      this.form.goods_info='';
    }
  },
  mounted () {
    this.getCategory();
    this.getCard();
    if(this.$route.query && this.$route.query.id != undefined){
      this.getRow(this.$route.query.id)

    }
  }
}
</script>
<style>
.goods{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// edit.vue?669878f4